import React from 'react';

export const PrimaryButton = ({ children, ...props }: { children: React.ReactNode } | React.ComponentProps<'button'>) => {
    return (
        <button
            className="rounded-lg h-11 md:text-xl text-base font-bold bg-[#26818E] text-white md:w-1/2 w-full"
            {...props}
        >
            {children}
        </button>
    )
};
